var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 276 276"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 266,
    x: 5,
    y: 5,
    fill: "#D74141",
    rx: 133
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 266,
    x: 5,
    y: 5,
    stroke: "#CB2222",
    strokeWidth: 10,
    rx: 133
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M90.135 72.952c-4.408-4.408-11.415-4.542-15.711-.246-5.155 5.154-5.02 12.162-.613 16.57l47.908 47.908-48.97 48.97c-4.296 4.296-4.161 11.304.246 15.712 4.417 4.416 11.424 4.551 15.72.255l48.971-48.971 49.038 49.038c4.408 4.408 11.415 4.543 16.57-.612 4.296-4.296 4.161-11.304-.247-15.711l-49.038-49.038 47.253-47.253c4.296-4.295 5.02-12.162.604-16.579-4.408-4.407-12.275-3.683-16.571.613l-47.252 47.252z",
    clipRule: "evenodd"
  })));
};
export default SvgError;